export const isHoldUntilValid = (v) => {
	const holdUntil = Date.parse(v);
	return !(isNaN(holdUntil) || holdUntil === 0 || v === "0001-01-01T00:00:00Z");
};

const isSameHoldUntil = (left, right) => {
	if (!isHoldUntilValid(left) || !isHoldUntilValid(right)) {
		return false;
	}
	return new Date(left).getTime() === new Date(right).getTime();
};

/**
 * Resolve hold_until for create/edit submit.
 *
 * The DatePicker returns midnight for a chosen day. We shift that to midday so a
 * user-picked hold lands in working hours. An existing system hold clock must be
 * left alone when the user is only editing other fields (BEZ-6097).
 */
export const resolveHoldUntilForSubmit = ({ holdUntil, existingHoldUntil, isEdit }) => {
	if (!isHoldUntilValid(holdUntil)) {
		return holdUntil;
	}

	const preservedHoldUntil = isEdit && isHoldUntilValid(existingHoldUntil)
		? existingHoldUntil
		: null;

	if (preservedHoldUntil !== null && isSameHoldUntil(holdUntil, preservedHoldUntil)) {
		return preservedHoldUntil;
	}

	const nextHoldUntil = new Date(holdUntil);
	nextHoldUntil.setHours(nextHoldUntil.getHours() + 12);
	return nextHoldUntil;
};
